
import { Component, Prop, Vue } from 'vue-property-decorator';
// import Model from './model';

@Component
export default class PageVue extends Vue {
  // @Prop() private msg!: string;
  // private model = new Model();
  @Prop() private pageBean!: any;
  private async handleCurrentChange(num: any) {
    // alert('num:' + num);
    this.pageBean.current = num;
    this.$emit('pagination', this.pageBean);
  }
}
